<script lang="ts">
    
    import Trivial from "../Components/Trivial/Trivial.svelte";
    import type { Fn } from '../global';
    import { getContext, onMount } from 'svelte';

    const playMainTheme: Fn = getContext('playMainTheme');

    onMount(playMainTheme);

    $: setBackgroundColor()

    function setBackgroundColor() {
        const doc = document.getElementsByTagName('body');

        if(!doc || doc.length == 0) return;

        doc[0].style.backgroundColor = '#4D373D';
    }
</script>

<div class="view">
    <Trivial />
</div>
